import { Box, styled } from '@mui/material';

import { COLORS } from '../../../../../configs/colors';

export const SkeletonCard = styled(Box)`
  background: ${COLORS.White};
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin: 8px 16px;
  padding: 16px 18px;
  overflow: hidden;
`;

export const SkeletonLine = styled(Box)<{ width?: string; height?: string }>`
  background: linear-gradient(90deg, #eef2f6 25%, #f8fafc 50%, #eef2f6 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
  height: ${({ height }) => height || '12px'};
  width: ${({ width }) => width || '100%'};
  margin-bottom: 8px;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export const SkeletonRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SkeletonCircle = styled(Box)<{ size?: string }>`
  width: ${({ size }) => size || '28px'};
  height: ${({ size }) => size || '28px'};
  border-radius: 50%;
  background: linear-gradient(90deg, #eef2f6 25%, #f8fafc 50%, #eef2f6 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  flex-shrink: 0;

  @keyframes shimmer {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export const ErrorCard = styled(Box)`
  background: ${COLORS.White};
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
`;

export const ErrorCardTitle = styled(Box)`
  font-weight: 700;
  font-size: 1rem;
  color: ${COLORS.Black};
`;

export const ErrorCardMessage = styled(Box)`
  font-size: 0.82rem;
  color: ${COLORS.MediumGrey};
  line-height: 1.5;
`;

export const RetryButton = styled('button')`
  background: linear-gradient(135deg, ${COLORS.NavyBlue} 0%, ${COLORS.NavyBlueDark} 100%);
  color: ${COLORS.White};
  border: none;
  cursor: pointer;
  padding: 10px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 0.82rem;
  margin-top: 4px;

  &:active {
    transform: scale(0.96);
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.NavyBlue};
    outline-offset: 2px;
  }
`;
